import { useApi } from '@shared/services/api-service';

export const useBankIdService = () => {
    const { post: bankIdStartApi } = useApi('/authenticate/start');
    const { post: bankIdSignApi } = useApi('/authenticate/sign');
    const { get: bankIdCancelApi } = useApi('/authenticate/cancel');
    const { get: bankIdStatusApi } = useApi('/authenticate/status');

    const startBankIdAuth = (device: string, isMobileDevice: boolean, sign: boolean): Promise<BankIdStartResponse | null> => {
        // used for logging in with bankId
        if (!sign) {
            return bankIdStartApi<BankIdStartResponse>({ device, isMobileDevice, sign })
                .then(data => data ?? null)
                .catch(err => {
                    console.error("Failed to start bankid auth", err);
                    return null;
                });
        } else {
            // Used for signing membership application
            return bankIdSignApi<BankIdStartResponse>({ device, isMobileDevice, sign })
                .then(data => data ?? null)
                .catch(err => {
                    console.error("Failed to start bankid sign", err);
                    return null;
                });
        }
    };
    const statusBankId = (sessionId: string): Promise<BankIdPollResponse | null> => {
        return bankIdStatusApi<BankIdPollResponse>(undefined, { sessionId })
            .then(data => data ?? null)
            .catch(err => {
                console.error("Failed to get bankid status", err);
                return null;
            });
    };

    const cancelBankId = async (sessionId: string): Promise<boolean> => {
        try {
            await bankIdCancelApi(undefined, { sessionId });
            return true;
        } catch (err) {
            console.error("Failed to cancel BankID session", err);
            return false;
        }
    };

    return {
        startBankIdAuth,
        statusBankId,
        cancelBankId,
    };
};